import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Copy from 'Src/components/Copy';
import { Flex } from 'Src/components/layout/Flex';

import { S2PCheckPaid } from './types';
import { NotificationUI } from './useNotification';

import styles from './S2PCheckPaidToastNotification.module.scss';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const sectionId = 'S2PCheckPaidToastNotification';

interface S2PCheckPaidToastNotificationProps {
  notification: NotificationUI<S2PCheckPaid>;
}

const S2PCheckPaidToastNotification: FC<S2PCheckPaidToastNotificationProps> = ({ notification }) => {
  const { t } = useTranslation();
  const { data } = notification;

  return (
    <Flex gap="sm" className={styles.root}>
      <Copy variant="body" weight="md" value={t('notification.s2pCheckPaid.title', { checkLabel: data.check.label })} />
      <Copy variant="body" size="sm" weight="regular" value={t('notification.s2pCheckPaid.message', { checkLabel: data.check.label })} />
    </Flex>
  );
};

export { S2PCheckPaidToastNotification };
